module.exports = {"svg":{"$":{"t":"1503994873331","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"10422","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"64","height":"64"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M64 448 320 448 320 960 64 960 64 448 64 448ZM704 256 960 256 960 960 704 960 704 256 704 256ZM384 64 640 64 640 960 384 960 384 64 384 64Z","p-id":"10423"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/chart.svg
// module id = Jgow
// module chunks = 1